import { EGoogleRedirectStatus } from 'constants/Google';
import React from 'react';
import StatusDisplayer from './StatusDisplayer';

const Denied = () => {
  return <StatusDisplayer status={EGoogleRedirectStatus.DENIED} />;
};

export default Denied;
